<ng-container *ngIf="loading">
  <div *ngIf="loading" class="preloader">
    <div class="lds-ripple">
      <div class="lds-pos"></div>
      <div class="lds-pos"></div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!loading">
  <app-live-version-security-issues-banner></app-live-version-security-issues-banner>
  <router-outlet *ngIf="_router.url === '/'"></router-outlet>

  <div
    *ngIf="_router.url !== '/' && !loading"
    id="main-wrapper"
    class="clsToolbarMainWrapper clsNoToolbarVisible"
    data-theme="light"
    data-layout="vertical"
    data-navbarbg="skin1"
    data-sidebartype="full"
    data-sidebar-position="fixed"
    data-header-position="fixed"
    data-boxed-layout="full"
  >
    <app-tour-navbar *ngIf="user.is_tour"></app-tour-navbar>
    <app-left-nav-bar
      *ngIf="
        user &&
        this._router.url !== '/readytostart' &&
        this._router.url !== '/onboarding'
      "
      (changeSection)="onSectionChange($event)"
      (selectionChange)="onSelectionChange($event)"
      [userInfo]="user"
      [isTabletOrPhone]="!isDesktopDevice"
      (sideBarExpanded)="onToggleSideBar($event)"
      (openChatbot)="openLightkeeperChatbot()"
      [ngClass]="{
        'left-sidebar-main':
          (!isDesktopDevice && collapsedSideBar) ||
          (isDesktopDevice && isMouseHovering),
        'left-sidebar-closed':
          (!isDesktopDevice && !collapsedSideBar) ||
          (isDesktopDevice && !isMouseHovering),
        'tour-margin': user.is_tour,
        liveAppHasSecurityIssuesTop: liveVersionSecurityBannerData !== null
      }"
      (mouseover)="onMouseHover()"
      (mouseout)="onMouseLeave()"
      onfocus="onmouseover"
      onblur="onmouseout"
    >
    </app-left-nav-bar>

    <div
      class="page-wrapper"
      [ngClass]="{
        'rightSection-closed':
          this._router.url !== '/readytostart' &&
          this._router.url !== '/onboarding',
        'tour-margin': user.is_tour,
        liveAppHasSecurityIssuesMarginTop:
          liveVersionSecurityBannerData !== null
      }"
      style="display: block"
    >
      <div
        id="divMainContent"
        [ngClass]="{
          onboardingContent:
            _router.url === '/readytostart' || _router.url === '/onboarding'
        }"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>
